/**
 * DATA SOURCE CONFIG
 * ──────────────────────────────────────────────────────────────────────────
 * Controls where each data type is loaded from. Change ONE value here and
 * every part of the app (Redux actions + direct calls) will switch sources.
 *
 *   'local'   → use the static data in Public/*-data.js (instant, no API)
 *   'backend' → fetch from the API and store in Redux
 *
 * Use 'local' while building/designing so you don't depend on the backend.
 * Switch to 'backend' when ready to wire up the real data.
 */

const DataSourceConfig = {
    categories:     'backend',    // 'local' | 'backend'
    services:       'local',    // 'local' | 'backend'
    bannerMessages: 'backend',  // 'local' | 'backend'
    links:          'backend',  // 'local' | 'backend'  (system assets)
    products:       'backend',  // always backend — no local mock yet
};

export default DataSourceConfig;
